var _path;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M19.646 19.854a.5.5 0 0 0 .708-.708l-8-8a.5.5 0 0 0-.708 0l-8 8a.5.5 0 0 0 .708.708L12 12.207zm0-8a.5.5 0 0 0 .708-.708l-8-8a.5.5 0 0 0-.708 0l-8 8a.5.5 0 0 0 .708.708L12 4.207z",
    clipRule: "evenodd"
  })));
});
const SvgDoubleChevronUp = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDoubleChevronUp);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xOS42NDY0IDE5Ljg1MzZDMTkuODQxNyAyMC4wNDg4IDIwLjE1ODMgMjAuMDQ4OCAyMC4zNTM2IDE5Ljg1MzZDMjAuNTQ4OCAxOS42NTgzIDIwLjU0ODggMTkuMzQxNyAyMC4zNTM2IDE5LjE0NjRMMTIuMzUzNiAxMS4xNDY0QzEyLjE1ODMgMTAuOTUxMiAxMS44NDE3IDEwLjk1MTIgMTEuNjQ2NCAxMS4xNDY0TDMuNjQ2NDUgMTkuMTQ2NEMzLjQ1MTE5IDE5LjM0MTcgMy40NTExOSAxOS42NTgzIDMuNjQ2NDUgMTkuODUzNkMzLjg0MTcxIDIwLjA0ODggNC4xNTgyOSAyMC4wNDg4IDQuMzUzNTUgMTkuODUzNkwxMiAxMi4yMDcxTDE5LjY0NjQgMTkuODUzNlpNMTkuNjQ2NCAxMS44NTM2QzE5Ljg0MTcgMTIuMDQ4OCAyMC4xNTgzIDEyLjA0ODggMjAuMzUzNiAxMS44NTM2QzIwLjU0ODggMTEuNjU4MyAyMC41NDg4IDExLjM0MTcgMjAuMzUzNiAxMS4xNDY0TDEyLjM1MzYgMy4xNDY0NUMxMi4xNTgzIDIuOTUxMTggMTEuODQxNyAyLjk1MTE4IDExLjY0NjQgMy4xNDY0NUwzLjY0NjQ1IDExLjE0NjRDMy40NTExOSAxMS4zNDE3IDMuNDUxMTkgMTEuNjU4MyAzLjY0NjQ1IDExLjg1MzZDMy44NDE3MSAxMi4wNDg4IDQuMTU4MjkgMTIuMDQ4OCA0LjM1MzU1IDExLjg1MzZMMTIgNC4yMDcxMUwxOS42NDY0IDExLjg1MzZaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPC9zdmc+Cg==";